import { jsx } from "react/jsx-runtime";
import { getSvgProps } from "./Icon.js";
import { Color } from "../svgs/large/templafy/index.js";
const IconTemplafyLargeColor = (iconProps)=>/*#__PURE__*/ jsx(Color, {
        ...getSvgProps(iconProps)
    });
export { IconTemplafyLargeColor };
